import { EnvironmentType } from '../schema/environment.enum';

export const API_URL: Record<EnvironmentType, string> = {
  [EnvironmentType.LOCAL]: 'https://api.dev.talbinah.net',
  [EnvironmentType.IN_MEMORY]: 'https://test.dev.talbinah.net',

  [EnvironmentType.DEV]: 'https://api.dev.talbinah.net',
  [EnvironmentType.TEST]: 'https://test.dev.talbinah.net',
  [EnvironmentType.RE_DESIGN]: 'https://redesign.talbinah.net',

  [EnvironmentType.STAGING]: 'https://test.dev.talbinah.net',
  [EnvironmentType.UAT]: 'https://uat.dev.talbinah.net',

  [EnvironmentType.LIVE]: 'https://api.talbinah.net',
  [EnvironmentType.PRODUCTION]: 'https://api.talbinah.net',
};


// apiUrl: "https://test.dev.talbinah.net",
// apiUrl: 'https://redesign.talbinah.net',
// apiUrl: 'https://api.dev.talbinah.net',
// apiUrl: 'https://uat.dev.talbinah.net',
// technicalSupportCollection: 'technicalSupportTest',
// apiUrl: 'https://api.talbinah.net',
